import React from 'react';

import classNames from 'classnames/bind';

const solidStyles = classNames.bind({
    primary: 'tw-bg-blue hover:tw-bg-blue-75 tw-text-white',
    danger: 'tw-bg-red hover:tw-bg-red-75 tw-text-white',
    success: 'tw-bg-green hover:tw-bg-green-75 tw-text-white',
    default: 'tw-bg-charcoal-75 hover:tw-bg-charcoal-50 tw-text-white',
});

const ghostStyles = classNames.bind({
    primary: 'tw-bg-transparent hover:tw-bg-blue-25 tw-text-blue',
    danger: 'tw-bg-transparent hover:tw-bg-red-25 tw-text-red',
    success: 'tw-bg-transparent hover:tw-bg-green-25 tw-text-green',
    default: 'tw-bg-transparent hover:tw-bg-charcoal-25 tw-text-charcoal',
});

const sizeStyles = classNames.bind({
    sm: 'tw-h-6 tw-w-6',
    md: 'tw-h-8 tw-w-8',
    lg: 'tw-h-10 tw-w-10',
});

export default function IconButton({ children, variant, size = 'md', ghost = false, className, ...props }) {
    const variantStyles = ghost ? ghostStyles : solidStyles;

    const buttonClass = classNames(
        'tw-rounded-full tw-flex tw-items-center tw-justify-center tw-border-0 focus:tw-outline-none disabled:tw-pointer-events-none disabled:tw-opacity-40',
        className,
        variantStyles({
            primary: variant === 'primary',
            danger: variant === 'danger',
            success: variant === 'success',
            default: !variant,
        }),
        sizeStyles({
            sm: size === 'sm',
            md: size === 'md',
            lg: size === 'lg',
        }),
    );

    return (
        <button {...props} type="button" className={buttonClass}>
            <div className="tw-inline-flex tw-items-center tw-justify-center">{children}</div>
        </button>
    );
}
